import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './styles.scss';

export function RemoveControl({ asSpan, children, className, ...props }) {
  props = { className: classNames('remove-control', className), ...props };

  if (asSpan) {
    return <span {...props}>&ndash; {children}</span>;
  } else {
    return <a {...props}>&ndash; {children}</a>;
  }
}

RemoveControl.propTypes = {
  asSpan: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default RemoveControl;
